import React, { type PropsWithChildren } from 'react';
import { Box, xcss } from '@atlaskit/primitives';
import { NavigationAppsNavItemWrapperNudgeAsync } from '@atlassian/jira-software-onboarding-nudges--next/src/ui/navigation-apps/async.tsx';
import { useHasOpened } from '@atlassian/jira-software-onboarding-quickstart-has-opened/src/services/has-opened/index.tsx';
import { fg } from '@atlassian/jira-feature-gating';

// When the Nav4Apps menuitem is rendered (which occurs both when the sidebar is visible AND hidden),
// AND when the quickstart tour is open
export function Nav4AppsSpotlightWrapper({ children }: PropsWithChildren) {
	const [{ hasOpened: shouldShowNudge }] = useHasOpened();

	if (fg('jira_onboarding_experiences_a11y_fixes')) {
		return !__SERVER__ && shouldShowNudge ? (
			<Box xcss={fullWidthStyles}>
				<NavigationAppsNavItemWrapperNudgeAsync>{children}</NavigationAppsNavItemWrapperNudgeAsync>
			</Box>
		) : (
			children
		);
	}

	return !__SERVER__ && shouldShowNudge ? (
		<NavigationAppsNavItemWrapperNudgeAsync>{children}</NavigationAppsNavItemWrapperNudgeAsync>
	) : (
		children
	);
}

const fullWidthStyles = xcss({
	width: '100%',
});
